export default __webpack_public_path__ + "static/media/head.5dd528b6.png";